"use client";
import React from "react";
import Image from "next/image";

import CardImg1 from "@/assets/whymsu/degree-experience-option2.jpg";
import CardImg2 from "@/assets/whymsu/degree-experience.jpg";
import CardImg4 from "@/assets/whymsu/stress-free-evaluation.jpg";
import CardImg5 from "@/assets/whymsu/digital-classroom.jpg";
import CardImg6 from "@/assets/whymsu/digital-dna.jpg";
import CardImg7 from "@/assets/whymsu/assured-employability.jpg";
import CardImg9 from "@/assets/whymsu/industry-professionals-as-mentors.jpg";

const cards = [
  {
    id: 1,
    title: "Do - Experience - Learn",
    text: "Learn by doing- 70% hands-on training that builds real skills through industry projects and practical exposure.",
    image: CardImg1,
  },
  {
    id: 2,
    title: "Degree + Experience",
    text: "Earn a recognised degree while gaining paid, first-year industry experience that accelerates your employability.",
    image: CardImg2,
  },
  {
    id: 3,
    title: "Stress Free Evaluation",
    text: "No rote learning- continuous, practical assessments that showcase what you can truly do.",
    image: CardImg4,
  },
  {
    id: 4,
    title: "Skill Certifications",
    text: "Stand out with industry-recognised skill certifications that validate your job-ready competencies.",
    image: CardImg5,
  },

  {
    id: 5,
    title: "On-the-Job Learning",
    text: "Future-focused training plus industry-integrated learning ensures strong placement outcomes and career growth.",
    image: CardImg7,
  },
  {
    id: 6,
    title: "Industry Professionals as Mentors",
    text: "Learn from experts. 80% faculty with top industry experience delivering real-world insights and guidance.",
    image: CardImg9,
  },
];

const ExperienceCards = () => {
  return (
    <section className="w-full  bg-white ">
      <div className="">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {cards.map((card) => (
            <article
              key={card.id}
              className="flex h-full group flex-col overflow-hidden border border-[#0000001C] bg-white"
              style={{
                transition:
                  "background-color 0.4s cubic-bezier(0.4,0,0.2,1)",
              }}
            >
              <div className="flex-1 px-6 py-5 transition-colors duration-300 group-hover:bg-[#f9a825]">
                <h3
                  className="mb-3 text-md font-bold md:text-[20px]"
                  style={{ fontFamily: "saans-bold" }}
                >
                  {card.title}
                </h3>
                <p
                  className="text-base leading-relaxed text-[#000000]"
                  style={{ fontFamily: "saans-regular" }}
                >
                  {card.text}
                </p>
              </div>

              <div className="relative  transition-colors duration-300 group-hover:bg-[#f9a825] h-44 w-full md:h-52 lg:h-64">
                <Image
                  src={card.image}
                  alt={card.title}
                  fill
                  className="object-cover"
                  loading="lazy"
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceCards;
